// extracted by mini-css-extract-plugin
export default {"container":"DTjNyx mz-default-dark-font"};